<template>
    <div style="position: relative;">
        <div v-if="type === '2'" class="verify-img-out"
             :style="{height: (parseInt(setSize.imgHeight) + vSpace) + 'px'}"
            >
            <div class="verify-img-panel" :style="{width: setSize.imgWidth,
                                                   height: setSize.imgHeight,}">
                <img :src="'data:image/png;base64,'+backImgBase" alt="" style="width:100%;height:100%;display:block">
                <div class="verify-refresh" @click="refresh" v-show="showRefresh"><i class="iconfont icon-refresh"></i>
                </div>
                <transition name="tips">
                    <span class="verify-tips" v-if="tipWords" :class="passFlag ?'suc-bg':'err-bg'">{{tipWords}}</span>
                </transition>
            </div>
        </div>
        <!-- 公共部分 -->
        <div class="verify-bar-area" :style="{width: setSize.imgWidth,
                                              height: barSize.height,
                                              'line-height':barSize.height}">
            <span class="verify-msg" v-text="text"></span>
            <div class="verify-left-bar"
                 :style="{width: (leftBarWidth!==undefined)?leftBarWidth: barSize.height, height: barSize.height, 'border-color': leftBarBorderColor, transaction: transitionWidth}">
                <span class="verify-msg" v-text="finishText"></span>
                <div class="verify-move-block"
                     @touchstart="start"
                     @mousedown="start"
                     :style="{width: barSize.height, height: barSize.height, 'background-color': moveBlockBackgroundColor, left: moveBlockLeft, transition: transitionLeft}">
                    <i :class="['verify-icon iconfont', iconClass]"
                       :style="{color: iconColor}"></i>
                    <div v-if="type === '2'" class="verify-sub-block"
                        :style="{'width':Math.floor(parseInt(setSize.imgWidth)*47/310)+ 'px',
                                  'height': setSize.imgHeight,
                                  'top':'-' + (parseInt(setSize.imgHeight) + vSpace) + 'px',
                                  'background-size': setSize.imgWidth + ' ' + setSize.imgHeight,
                                  }">
                        <img :src="'data:image/png;base64,'+blockBackImgBase" alt=""  style="width:100%;height:100%;display:block;-webkit-user-drag:none;">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    /**
     * VerifySlide
     * @description 滑块
     * */
    import {aesEncrypt} from "./../utils/ase"
    import {resetSize} from './../utils/util'
    import {reqGet,reqCheck}  from "./../api/index"

    export default {
        name: 'VerifySlide',
        props: {
            captchaType:{
                type:String,
            },
            type: {
                type: String,
                default: '1'
            },
            mode: {
                type: String,
                default: 'fixed'
            },
            vSpace: {
                type: Number,
                default: 5
            },
            explain: {
                type: String,
                default: '向右滑动完成验证'
            },
            imgSize: {
                type: Object,
                default() {
                    return {
                        width: '310px',
                        height: '155px'
                    }
                }
            },
            blockSize: {
                type: Object,
                default() {
                    return {
                        width: '50px',
                        height: '50px'
                    }
                }
            },
            barSize: {
                type: Object,
                default() {
                    return {
                        width: '310px',
                        height: '40px'
                    }
                }
            }
        },
        data() {
            return {
                secretKey: '',
                passFlag: '',
                backImgBase: '',
                blockBackImgBase: '',
                backToken: '',
                startMoveTime: '',
                endMovetime: '',
                tipsBackColor: '',
                tipWords: '',
                text: '',
                finishText: '',
                setSize: {
                    imgHeight: 0,
                    imgWidth: 0,
                    barHeight: 0,
                    barWidth: 0
                },
                moveBlockLeft: undefined,
                leftBarWidth: undefined,
                moveBlockBackgroundColor: undefined,
                leftBarBorderColor: '#ddd',
                iconColor: undefined,
                iconClass: 'icon-right',
                status: false,
                isEnd: false,
                showRefresh: true,
                transitionLeft: '',
                transitionWidth: '',
                startLeft: 0
            }
        },
        computed: {
            barArea() {
                return this.$el.querySelector('.verify-bar-area')
            }
        },
        watch: {
            type() {
                this.init()
            }
        },
        mounted() {
            this.init()
            this.$el.onselectstart = function () {
                return false
            }
        },
        methods: {
            init() {
                var self = this
                this.text = this.explain
                this.getPictrue()
                this.$nextTick(function() {
                    var sizeObj = resetSize(self)
                    self.setSize.imgHeight = sizeObj.imgHeight
                    self.setSize.imgWidth = sizeObj.imgWidth
                    self.setSize.barHeight = sizeObj.barHeight
                    self.setSize.barWidth = sizeObj.barWidth
                    self.$parent.$emit('ready', self)
                })

                window.removeEventListener("touchmove", this._bindMove)
                window.removeEventListener("mousemove", this._bindMove)
                window.removeEventListener("touchend", this._bindEnd)
                window.removeEventListener("mouseup", this._bindEnd)

                this._bindMove = function(e) { self.move(e) }
                this._bindEnd = function() { self.end() }

                window.addEventListener("touchmove", this._bindMove)
                window.addEventListener("mousemove", this._bindMove)
                window.addEventListener("touchend", this._bindEnd)
                window.addEventListener("mouseup", this._bindEnd)
            },
            start(e) {
                e = e || window.event
                var x
                if (!e.touches) {
                    x = e.clientX
                } else {
                    x = e.touches[0].pageX
                }
                this.startLeft = Math.floor(x - this.barArea.getBoundingClientRect().left)
                this.startMoveTime = +new Date()
                if (this.isEnd == false) {
                    this.text = ''
                    this.moveBlockBackgroundColor = '#337ab7'
                    this.leftBarBorderColor = '#337AB7'
                    this.iconColor = '#fff'
                    e.stopPropagation()
                    this.status = true
                }
            },
            move(e) {
                e = e || window.event
                if (this.status && this.isEnd == false) {
                    var x
                    if (!e.touches) {
                        x = e.clientX
                    } else {
                        x = e.touches[0].pageX
                    }
                    var bar_area_left = this.barArea.getBoundingClientRect().left
                    var move_block_left = x - bar_area_left
                    if (move_block_left >= this.barArea.offsetWidth - parseInt(parseInt(this.blockSize.width) / 2) - 2) {
                        move_block_left = this.barArea.offsetWidth - parseInt(parseInt(this.blockSize.width) / 2) - 2
                    }
                    if (move_block_left <= 0) {
                        move_block_left = parseInt(parseInt(this.blockSize.width) / 2)
                    }
                    this.moveBlockLeft = (move_block_left - this.startLeft) + "px"
                    this.leftBarWidth = (move_block_left - this.startLeft) + "px"
                }
            },
            end() {
                var self = this
                this.endMovetime = +new Date()
                if (this.status && this.isEnd == false) {
                    var moveLeftDistance = parseInt((this.moveBlockLeft || '').replace('px', ''))
                    moveLeftDistance = moveLeftDistance * 310 / parseInt(this.setSize.imgWidth)
                    var data = {
                        captchaType: this.captchaType,
                        "pointJson": this.secretKey ? aesEncrypt(JSON.stringify({x: moveLeftDistance, y: 5.0}), this.secretKey) : JSON.stringify({x: moveLeftDistance, y: 5.0}),
                        "token": this.backToken
                    }
                    reqCheck(data).then(function(res) {
                        if (res.repCode == "0000") {
                            self.moveBlockBackgroundColor = '#5cb85c'
                            self.leftBarBorderColor = '#5cb85c'
                            self.iconColor = '#fff'
                            self.iconClass = 'icon-check'
                            self.showRefresh = false
                            self.isEnd = true
                            if (self.mode == 'pop') {
                                setTimeout(function() {
                                    self.$parent.clickShow = false
                                    self.refresh()
                                }, 1500)
                            }
                            self.passFlag = true
                            self.tipWords = ((self.endMovetime - self.startMoveTime) / 1000).toFixed(2) + 's验证成功'
                            var captchaVerification = self.secretKey ? aesEncrypt(self.backToken + '---' + JSON.stringify({x: moveLeftDistance, y: 5.0}), self.secretKey) : self.backToken + '---' + JSON.stringify({x: moveLeftDistance, y: 5.0})
                            setTimeout(function() {
                                self.tipWords = ""
                                self.$parent.closeBox()
                                self.$parent.$emit('success', {captchaVerification: captchaVerification})
                            }, 1000)
                        } else {
                            self.moveBlockBackgroundColor = '#d9534f'
                            self.leftBarBorderColor = '#d9534f'
                            self.iconColor = '#fff'
                            self.iconClass = 'icon-close'
                            self.passFlag = false
                            setTimeout(function() {
                                self.refresh()
                            }, 1000)
                            self.$parent.$emit('error', self)
                            self.tipWords = "验证失败"
                            setTimeout(function() {
                                self.tipWords = ""
                            }, 1000)
                        }
                    })
                    this.status = false
                }
            },
            refresh() {
                this.showRefresh = true
                this.finishText = ''
                this.transitionLeft = 'left .3s'
                this.moveBlockLeft = 0
                this.leftBarWidth = undefined
                this.transitionWidth = 'width .3s'
                this.leftBarBorderColor = '#ddd'
                this.moveBlockBackgroundColor = '#fff'
                this.iconColor = '#000'
                this.iconClass = 'icon-right'
                this.isEnd = false
                this.getPictrue()
                var self = this
                setTimeout(function() {
                    self.transitionWidth = ''
                    self.transitionLeft = ''
                    self.text = self.explain
                }, 300)
            },
            getPictrue() {
                var self = this
                var data = {
                    captchaType: this.captchaType
                }
                reqGet(data).then(function(res) {
                    if (res.repCode == "0000") {
                        self.backImgBase = res.repData.originalImageBase64
                        self.blockBackImgBase = res.repData.jigsawImageBase64
                        self.backToken = res.repData.token
                        self.secretKey = res.repData.secretKey
                    } else {
                        self.tipWords = res.repMsg
                    }
                })
            }
        }
    }
</script>

